import { useTranslation } from "react-i18next";
import { createFileRoute, Link } from "@tanstack/react-router";
import { buttonVariants } from "@/components/ui/button";
import { CreateClientCredentialForm } from "@/components/ClientCredentials/CreateClientCredentialForm";

export const Route = createFileRoute("/_authenticated/client-credentials/new")({
  component: NewClientCredential,
});

function NewClientCredential() {
  const { t } = useTranslation();
  return (
    <div className="container mx-auto space-y-6 p-4">
      <Link className={buttonVariants({ variant: "outline" })} to="/client-credentials">
        {t("Back to API Access")}
      </Link>
      <CreateClientCredentialForm />
    </div>
  );
}
